module.exports = __webpack_public_path__ + "images/emoji/heavy_dollar_sign.0eb327cd077083ae4eec.png";